/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Meetinglink_Label1Inputs */

const en_job_form_meetinglink_label1 = /** @type {(inputs: Job_Form_Meetinglink_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meeting link`)
};

const de_job_form_meetinglink_label1 = /** @type {(inputs: Job_Form_Meetinglink_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meeting-Link`)
};

/**
* | output |
* | --- |
* | "Meeting link" |
*
* @param {Job_Form_Meetinglink_Label1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_meetinglink_label1 = /** @type {((inputs?: Job_Form_Meetinglink_Label1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Meetinglink_Label1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_meetinglink_label1(inputs)
	return en_job_form_meetinglink_label1(inputs)
});
export { job_form_meetinglink_label1 as "job_form_meetingLink_label" }